<template>
    <div>
    <app-toolbarcustom :app_title="data.title" app_menu="hrspt"></app-toolbarcustom>
        <div class="mb-15"></div>
        <v-progress-linear
        indeterminate
        color="fourth"
        rounded
        v-if="loading.page"
        ></v-progress-linear>
        <template>
        <v-row
            align="center"
            justify="space-around"
            v-if="posts.length > 0"
        >
        <v-btn
        text
        class="mt-5"
        color="primary"
        @click="ToggleCheckbox"
        >
        Centang/Uncentang
        </v-btn>
        <v-btn
        color="error"
        class="mt-5"
        @click="Confirm('multispt')"
        v-if="$functions.UsersType() === 'HR-MGR' || $functions.UsersType() === 'GROUP'"
        >
        Proses SPT
        </v-btn>
        </v-row>
        </template>
        <div class="ml-4" v-if="posts.length > 0">TOTAL: {{  $functions.NewFormatNumber(SumCheckList) }} </div>
        <v-card
            class="mx-auto mb-2"
            max-width="344"
            outlined
            v-for="row in posts"
            :key="row.doc_id"
        >
            <v-list-item three-line>
            <v-list-item-content>
                <div class="text-overline mb-4" v-if="row.doc_sdate !== row.doc_edate">
                {{ $functions.FormatDateIndoWithDayName(row.doc_sdate) }} s/d
                {{ $functions.FormatDateIndoWithDayName(row.doc_edate) }}
                </div>
                <div class="text-overline mb-4" v-else>{{ $functions.FormatDateIndoWithDayName(row.doc_sdate) }}</div>
                <div>
                    {{row.doc_remarks}}
                </div>
            </v-list-item-content>
            <v-list-item-avatar
                size="80"
                color="grey"
            >
                <img :src="row.doc_usersavatarurl">
            </v-list-item-avatar>
            </v-list-item>
           
            <v-card-actions>
            <small class="ml-2"><v-icon>money</v-icon> IDR {{ $functions.NewFormatNumber(row.doc_total) }}</small><v-spacer></v-spacer>
            <small>{{row.doc_usersname}}</small>
            <v-checkbox
            input-value="true"
            value
            v-model="row.checked"
            ></v-checkbox>
            </v-card-actions>
        </v-card>
        <infinite-loading @infinite="ListInfinite" v-if="posts.length >= pages.limit"></infinite-loading>
        <div class="mt-10">&nbsp;</div>
        <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
        <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            checkAll: false,
            posts:[],
            data: {
                title: ''
            },
            loading: {
                page: false
            },
            pages: {
                limit:100,
                offset:100,
                fetch:100,
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            }
        }),
        computed: {
            //Production Channel
            SumCheckList() {
                return this.posts.reduce((total, current) => {
                    return current.checked ? total + current.doc_total : total;
                }, 0)
            },
        },
        created() {
            this.FirstLoad()
        },
        methods: {
            ListInfinite($state) {
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                let formdata = {
                  doc_type: decode,
                  doc_company: this.$functions.UsersCompany(),
                  order_by: 'doc_id',
                  order_type: 'DESC',
                  offset: this.$functions.ConvNom(this.pages.offset),
                  fetch: this.$functions.ConvNom(this.pages.fetch),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListPendingSPT'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(({data}) => {
                    if (data.length) {
                        this.pages.offset = this.pages.offset + this.pages.fetch
                        this.posts.push(...data.map(post => ({ ...post, checked: false })))
                        $state.loaded()
                    } else {
                        $state.complete()
                    }
                })
            },
            FirstLoad () {
                this.loading.page = true
                let decode = this.$functions.DecodeUrl(this.$route.params.id)
                if (decode === 'transportation') {
                    this.data.title = 'SPT Transportasi'
                } else if (decode === 'entertainment') {
                    this.data.title = 'SPT Entertainment'
                } else if (decode === 'medical') {
                    this.data.title = 'SPT Kesehatan'
                }
                let formdata = {
                  doc_type: decode,
                  doc_company: this.$functions.UsersCompany(),
                  order_by: 'doc_id',
                  order_type: 'DESC',
                  limit: this.$functions.ConvNom(this.pages.limit),
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListPendingSPT'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts = feedback.map(post => ({ ...post, checked: false }))
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            GoTo (id) {
                this.$router.push({name: 'employeemedicaldetail',params:{id:this.$functions.EncodeUrl(id)}})
            },
            Confirm (flag) {
                if (flag === 'multispt') {
                    const checkedItems = this.posts.filter(post => post.checked)
                    if (checkedItems.length === 0) {
                        this.SnackBar(true, 'error', 'Tidak ada data yang dicentang', 3000);
                        return
                    }
                    this.url_type = flag
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Proses'
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                this.confirm.ok = 'Loading...'
                if (this.url_type === 'multispt') {
                    this.ProcessChecked()
                }
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            },
            ToggleCheckbox() {
                this.checkAll = !this.checkAll;
                this.posts = this.posts.map(post => {
                    post.checked = this.checkAll;
                    return post;
                });
            },
            ProcessChecked() {
                const checkedItems = this.posts.filter(post => post.checked)

                if (checkedItems.length === 0) {
                    this.SnackBar(true, 'error', 'Tidak ada data yang dicentang', 3000);
                    return
                }

                // Contoh struktur JSON yang akan dikirim
                const payload = JSON.stringify(checkedItems.map(item => ({
                    doc_type: item.doc_type,
                    doc_id: item.doc_id
                })))

                let param = this.$functions.ParamPOST({ url_type: this.url_type, letter_type: this.$functions.DecodeUrl(this.$route.params.id),multi_data: payload })

                this.$axios.post(this.$functions.UrlPOST('apiWriteLetter'), param, {
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.SnackBar(true, 'success', 'Proses Sukses', 3000)
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    }
                    this.confirm.dialog   = false
                    this.confirm.ok       = 'OK'
                    this.FirstLoad()
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                })
            }
        }
    }
</script>